import React from 'react'
import { createIcon } from '@chakra-ui/react'

export const SwapVerticalBase = (
  <path
    fill='currentColor'
    d='M10.888 8.544c.155-.066.331-.03.45.093l2.478 2.06c.161.168.161.44 0 .606l-2.478 2.049c-.119.122-.295.159-.45.093-.154-.066-.255-.223-.255-.397v-1.07H2.412c-.228 0-.413-.19-.413-.428v-1.126c0-.237.185-.429.413-.429h8.221V8.94c0-.173.1-.33.255-.396zM4.662 2.648c.119-.122.295-.159.45-.093.154.066.255.223.255.397v1.07h8.221c.228 0 .413.19.413.428v1.126c0 .237-.185.429-.413.429H5.367V7.06c0 .173-.1.33-.255.396s-.331.03-.45-.093l-2.478-2.06c-.161-.168-.161-.44 0-.606z'
    transform='rotate(90 8 8)'
  />
)

export const SwapVertical = createIcon({
  displayName: 'SwapVertical',
  viewBox: '0 0 16 16',
  path: SwapVerticalBase,
})
